export const site = {
  name: "Aesthetic Bio Maker",
  operatorName: "Aesthetic Bio Maker",
  origin: "https://aestheticbiomaker.com",
  supportEmail: "support@aestheticbiomaker.com",
  description: "Free copy-ready aesthetic bios for Instagram, Discord, Roblox, TikTok, and social profiles."
} as const;

// Match the site's existing trailing-slash URL convention.
export const policyLinks = [
  { key: "about", path: "/about-us/", label: "About", spanishLabel: "Acerca de" },
  { key: "contact", path: "/contact-us/", label: "Contact", spanishLabel: "Contacto" },
  { key: "privacy", path: "/privacy-policy/", label: "Privacy Policy", spanishLabel: "Privacidad" },
  { key: "terms", path: "/terms-of-service/", label: "Terms of Use", spanishLabel: "Condiciones de uso" }
] as const;

export type PolicyKey = (typeof policyLinks)[number]["key"];

export function policyPath(key: PolicyKey) {
  return policyLinks.find((link) => link.key === key)!.path;
}
